import type { Platform } from '@tbitop/platform';
import type Keycloak from 'keycloak-js';
import type { KeycloakAdapter } from 'keycloak-js';
import { defaultTo, omit } from 'lodash-es';
import type { AuthenticationConfig } from './authentication-config';

export type PlatformAuthenticationConfig = Omit<AuthenticationConfig, 'redirectUris'> & {
  redirectUri: string;
  createAdapter: (instance: Keycloak) => KeycloakAdapter | undefined;
};

export const toPlatformAuthenticationConfig = (config: AuthenticationConfig, platform: Platform): PlatformAuthenticationConfig => ({
  ...omit(config, 'rediredirectUris'),
  redirectUri: defaultTo(config.redirectUris[platform], getSanitizedCurrentUrl()),
  createAdapter: instance => new config.adapter(instance),
});

function getSanitizedCurrentUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete('realm');
  url.hash = '';
  return url.toString();
}
